// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Color} from './color.js'
import {InkStyle} from './ink-style.js'
import {InkTool} from './ink-tool.js'
import {MeasurementUnit} from './measurement-unit.js'
import {Point} from './point.js'
import {SeqId} from './seq-id.js'
import {
  ShapeDefinitionType,
  unionListToShapeDefinitionType,
  unionToShapeDefinitionType
} from './shape-definition-type.js'
import {Size} from './size.js'
import {TapePattern} from './tape-pattern.js'

export class CreateShape {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): CreateShape {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsCreateShape(bb: flatbuffers.ByteBuffer, obj?: CreateShape): CreateShape {
    return (obj || new CreateShape()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsCreateShape(bb: flatbuffers.ByteBuffer, obj?: CreateShape): CreateShape {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new CreateShape()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  page(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  origin(obj?: Point): Point | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new Point()).__init(this.bb_pos + offset, this.bb!) : null
  }

  rotation(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : null
  }

  scale(obj?: Size): Size | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new Size()).__init(this.bb_pos + offset, this.bb!) : null
  }

  definitionType(): ShapeDefinitionType {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : ShapeDefinitionType.NONE
  }

  definition<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null
  }

  tool(): InkTool {
    const offset = this.bb!.__offset(this.bb_pos, 16)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : InkTool.Pen
  }

  style(): InkStyle {
    const offset = this.bb!.__offset(this.bb_pos, 18)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : InkStyle.FixedWidth
  }

  tapePattern(): TapePattern | null {
    const offset = this.bb!.__offset(this.bb_pos, 20)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  color(obj?: Color): Color | null {
    const offset = this.bb!.__offset(this.bb_pos, 22)
    return offset ? (obj || new Color()).__init(this.bb_pos + offset, this.bb!) : null
  }

  borderWidth(): number {
    const offset = this.bb!.__offset(this.bb_pos, 24)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : 4.0
  }

  fillColor(obj?: Color): Color | null {
    const offset = this.bb!.__offset(this.bb_pos, 26)
    return offset ? (obj || new Color()).__init(this.bb_pos + offset, this.bb!) : null
  }

  zIndex(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 28)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  smartHighlight(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 30)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false
  }

  force(): number | null {
    const offset = this.bb!.__offset(this.bb_pos, 32)
    return offset ? this.bb!.readFloat32(this.bb_pos + offset) : null
  }

  positionLocked(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 34)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : false
  }

  inkEffects(): bigint {
    const offset = this.bb!.__offset(this.bb_pos, 36)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : BigInt('0')
  }

  inkEffectsTinted(): boolean {
    const offset = this.bb!.__offset(this.bb_pos, 38)
    return offset ? !!this.bb!.readInt8(this.bb_pos + offset) : true
  }

  measurementUnit(): MeasurementUnit | null {
    const offset = this.bb!.__offset(this.bb_pos, 40)
    return offset ? this.bb!.readInt8(this.bb_pos + offset) : null
  }

  static startCreateShape(builder: flatbuffers.Builder) {
    builder.startObject(19)
  }

  static addPage(builder: flatbuffers.Builder, pageOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, pageOffset, 0)
  }

  static addOrigin(builder: flatbuffers.Builder, originOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, originOffset, 0)
  }

  static addRotation(builder: flatbuffers.Builder, rotation: number) {
    builder.addFieldFloat32(2, rotation, null)
  }

  static addScale(builder: flatbuffers.Builder, scaleOffset: flatbuffers.Offset) {
    builder.addFieldStruct(3, scaleOffset, 0)
  }

  static addDefinitionType(builder: flatbuffers.Builder, definitionType: ShapeDefinitionType) {
    builder.addFieldInt8(4, definitionType, ShapeDefinitionType.NONE)
  }

  static addDefinition(builder: flatbuffers.Builder, definitionOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, definitionOffset, 0)
  }

  static addTool(builder: flatbuffers.Builder, tool: InkTool) {
    builder.addFieldInt8(6, tool, InkTool.Pen)
  }

  static addStyle(builder: flatbuffers.Builder, style: InkStyle) {
    builder.addFieldInt8(7, style, InkStyle.FixedWidth)
  }

  static addTapePattern(builder: flatbuffers.Builder, tapePattern: TapePattern) {
    builder.addFieldInt8(8, tapePattern, null)
  }

  static addColor(builder: flatbuffers.Builder, colorOffset: flatbuffers.Offset) {
    builder.addFieldStruct(9, colorOffset, 0)
  }

  static addBorderWidth(builder: flatbuffers.Builder, borderWidth: number) {
    builder.addFieldFloat32(10, borderWidth, 4.0)
  }

  static addFillColor(builder: flatbuffers.Builder, fillColorOffset: flatbuffers.Offset) {
    builder.addFieldStruct(11, fillColorOffset, 0)
  }

  static addZIndex(builder: flatbuffers.Builder, zIndex: bigint) {
    builder.addFieldInt64(12, zIndex, null)
  }

  static addSmartHighlight(builder: flatbuffers.Builder, smartHighlight: boolean) {
    builder.addFieldInt8(13, +smartHighlight, +false)
  }

  static addForce(builder: flatbuffers.Builder, force: number) {
    builder.addFieldFloat32(14, force, null)
  }

  static addPositionLocked(builder: flatbuffers.Builder, positionLocked: boolean) {
    builder.addFieldInt8(15, +positionLocked, +false)
  }

  static addInkEffects(builder: flatbuffers.Builder, inkEffects: bigint) {
    builder.addFieldInt64(16, inkEffects, BigInt('0'))
  }

  static addInkEffectsTinted(builder: flatbuffers.Builder, inkEffectsTinted: boolean) {
    builder.addFieldInt8(17, +inkEffectsTinted, +true)
  }

  static addMeasurementUnit(builder: flatbuffers.Builder, measurementUnit: MeasurementUnit) {
    builder.addFieldInt8(18, measurementUnit, null)
  }

  static endCreateShape(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // page
    builder.requiredField(offset, 6) // origin
    builder.requiredField(offset, 14) // definition
    builder.requiredField(offset, 22) // color
    return offset
  }
}
